import React, { useContext } from 'react';
import { Redirect } from 'cccisd-react-router';
import { CPProgressContext } from '../../hooks/CPProgress/context';

const Fortress = window.cccisd.fortress;

function CPRedirector() {
    const cpProgress = useContext(CPProgressContext);

    const respondentHash = Fortress.user.acting.respondent_hash;

    // don't redirect until initial data has loaded
    if (!cpProgress.isLoaded) {
        return <span />;
    }

    if (!cpProgress.isBaselineDone) {
        return <Redirect to={`/d/${cpProgress.cpBaselineHash}/${respondentHash}`} />;
    }

    return <Redirect to={`/d/${cpProgress.cpInterventionHash}/${respondentHash}`} />;
}

export default CPRedirector;
